import { isRecord } from '@apps/web/components/phoebe_chat/record_utils';
import { SETTINGS_SURFACE_TOOL_NAMES } from '@apps/web/components/phoebe_chat_view/tool_calls/surface_organization_setting_tool_ui';
import { isUserInputToolName } from '@apps/web/components/phoebe_chat_view/tool_calls/tool_name_constants';
import {
    type RenderTimelineEntry,
    type ToolExecutionEntry,
} from '@apps/web/components/phoebe_chat_view/transcript_types';

export function isMonitoringToolEntry(entry: ToolExecutionEntry): boolean {
    return entry.name === 'monitor_outreach';
}

export function isUserQuestionToolEntry(entry: ToolExecutionEntry): boolean {
    return isUserInputToolName(entry.name);
}

// `surface_organization_setting` emits an interactive settings card. Like
// the user-input tools, it must render as a first-class timeline card — the
// general agent hides/collapses ordinary completed tool rows, which would bury
// the control.
export function isSurfaceSettingToolEntry(entry: ToolExecutionEntry): boolean {
    return SETTINGS_SURFACE_TOOL_NAMES.has(entry.name);
}

function isTeachPhoebeTrainingContext(value: unknown): boolean {
    return typeof value === 'string' && value.trim().length > 0;
}

export function isTeachPhoebeUserQuestion(entry: ToolExecutionEntry): boolean {
    const args = isRecord(entry.arguments) ? entry.arguments : {};
    if (isTeachPhoebeTrainingContext(args['training_context'])) {
        return true;
    }

    const questions = args['questions'];
    return (
        Array.isArray(questions) &&
        questions.some(
            (question) =>
                isRecord(question) &&
                isTeachPhoebeTrainingContext(question['training_context']),
        )
    );
}

export function shouldRenderToolEntryTopLevel(
    entry: ToolExecutionEntry,
): boolean {
    const waitsForUserAction =
        entry.status === 'pending_approval' ||
        entry.status === 'pending_user_input';
    return (
        isUserQuestionToolEntry(entry) ||
        isSurfaceSettingToolEntry(entry) ||
        (waitsForUserAction && !entry.isComplete)
    );
}

export function isPendingApprovalToolExecutionEntry(
    entry: RenderTimelineEntry,
): entry is ToolExecutionEntry {
    return (
        entry.kind === 'tool-execution' &&
        entry.status === 'pending_approval' &&
        !entry.isComplete
    );
}
